import removeDecimal from "./RemoveDecimal";

const monetisedInputs = (data) => Object.fromEntries(
  Object.entries(data)
    .map(([key, value]) => (key.indexOf("Cost") > 0) && [key, removeDecimal(value)])
    .filter(Boolean)
);

export default monetisedInputs;
